import React from 'react';
import PropTypes from 'prop-types';
import {Trans} from '@lingui/react';
import {useSelector} from 'react-redux';

import FlatButton from '../../FlatButton';
import ArrowRightIcon from '../../Icons/ArrowRightIcon';
import PeopleIcon from '../../Icons/PeopleIcon';
import ClockIcon from '../../Icons/ClockIcon';
import CompletedIcon from '../../Icons/CompletedIcon';
import EyeOutlineIcon from '../../Icons/EyeOutlineIcon';
import PencilStrokedIcon from '../../Icons/PencilStrokedIcon';

import {formatDate} from '@services/utilities';

import cls from 'classnames';
import s from './EvaluationItem.css';

export default function EvaluationItem(props) {
  const {test, createdOn, onClick} = props;

  const lang = useSelector(state => state.getIn(['userCampaign', 'data', 'user', 'lang']));

  const user_evaluated = test.get('user_is_evaluated');
  const evaluationType = test.get('label');

  const cutLang = lang.split('_')[1];

  return (
    <div className={s.EvaluationItem}>
      <div className={cls(s.ItemStatus, user_evaluated === 'n' && s.NotStarted)}>
        {(() => {
          if (user_evaluated === 'n')
            return (
              <span>
                <Trans id="evaluation_item.label_start">Inizia</Trans>
              </span>
            );
          else if (user_evaluated === 'p')
            return (
              <span>
                <Trans id="evaluation_item.label_continue">Continua</Trans>
              </span>
            );
          else if (user_evaluated === 'y')
            return (
              <span>
                <Trans id="evaluation_item.label_modify">Modifica</Trans>
              </span>
            );
        })()}
      </div>

      <div className={s.ItemDetails}>
        <div className={s.ItemName}>
          {test.get('firstName')} <br /> {test.get('lastName')}
        </div>

        <div className={s.ItemInfo}>
          <div className={s.Info}>
            <PeopleIcon />
            <span>{evaluationType || 'N/A'}</span>
          </div>
        </div>
      </div>

      <div className={s.ItemActions}>
        {(() => {
          if (user_evaluated === 'n')
            return <PencilStrokedIcon className={cls(s.TestStatusIcon, s.StrokedIcon)} />;
          else if (user_evaluated === 'p') return <EyeOutlineIcon className={s.TestStatusIcon} />;
          else if (user_evaluated === 'y') return <CompletedIcon className={s.TestStatusIcon} />;
        })()}

        <FlatButton className={s.EnterTestButton} onClick={onClick}>
          <span className="visually-hidden">
            <Trans id="evaluation_item.eval">Valuta</Trans> {test.get('firstName')}{' '}
            {test.get('lastName')}
          </span>
          <ArrowRightIcon />
        </FlatButton>
      </div>
    </div>
  );
}

EvaluationItem.propTypes = {
  onClick: PropTypes.func,
  test: PropTypes.object,
  createdOn: PropTypes.string,
};
